export const maxFileSize = 15;
export const maxTotalFilesSize = 15;
export const maxNumberOfFiles = 5;
export const columnGridCount = 12;
export const allowedMimeTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/x-png',
    'image/jpe',
    'image/jpg',
    'image/jpeg',
    'image/png',
];
